import { AuthGuard, AuthGuardProps } from './AuthGuard'

export const NotAuthGuard = ({ children, fallback = null }: AuthGuardProps) => (
  <AuthGuard fallback={children}>{fallback}</AuthGuard>
)
